import axios from 'axios';
import { reactLocalStorage } from 'reactjs-localstorage';

let headers = {};
const origin = window.location.origin
let BACKEND_URL = "https://nefos-api.aventusdemo.com/api/"
if (origin === 'https://nefos.aventusdemo.com') {
    BACKEND_URL = "https://nefos-api.aventusdemo.com/api/"
}
else if (origin === 'https://nefos.aventusinformatics.in') {
    BACKEND_URL = "https://nefos-api.aventusinformatics.in/api/"
}
else if (origin === 'https://nefos-uat.aventusinformatics.com') {
    BACKEND_URL = "https://nefos-uatapi.aventusinformatics.com/api/"
}
else if (origin === 'https://www.nefos.in') {
    BACKEND_URL = "https://api.nefos.in/api/"
}
else {
    BACKEND_URL = "https://nefos-api.aventusdemo.com/api/"
}


const axiosInstance = axios.create({
    baseURL: BACKEND_URL,
    headers
});

axiosInstance.interceptors.request.use(
    async (config) => {
        const token = reactLocalStorage.get('token');
        const userData = JSON.parse(localStorage.getItem('user_info'))
        let branch = localStorage.getItem("branch") && localStorage.getItem("branch") !== 'undefined' ? JSON.parse(localStorage.getItem("branch")) : ''

        if (token) {
            config.headers.Authorization = `Bearer ${token}`;
        }
        if (userData?.is_superuser === false) {
            config.headers.Museum = userData?.museum
        }

        if (branch) {
            config.params = {
                ...config.params,
                branch: branch?.value
            }

        }
        return config;
    },
    (error) => {
        return Promise.reject(error);
    },
);

axiosInstance.interceptors.response.use(
    (response) =>
        new Promise((resolve, reject) => {
            resolve(response);
        }),
    (error) => {
        if (!error.response) {
            return new Promise((resolve, reject) => {
                reject(error);
            });
        }

        if (error.response.status === 403) {

        }
        else if (error.response.status === 401) {
            localStorage.clear()
            if (window.location.pathname !== "/login") {
                window.location = "/login";
            }
        }
        else {
            return new Promise((resolve, reject) => {
                reject(error);
            });
        }
    },
);

export default axiosInstance;